import { OrganizationStaffRoleType } from '@/shared/api/protocol-ts/model/dto_organization_staff_pb';

export const isTreatingDoctor = (role: OrganizationStaffRoleType | undefined) =>
  role ===
  OrganizationStaffRoleType.OrganizationStaffRoleType_LimitedClinicalAccess;
